export default {
    postDispatch:    { method: 'post', url: 'databricks-import-runs/dispatch' },
    cancelBatch:     { method: 'post', url: 'databricks-import-runs/cancel' },
    getCurrentBatch: { method: 'get',  url: 'databricks-import-runs/batches/current' },
    getHistory:      { method: 'get',  url: 'databricks-import-runs/batches' },
    getBatchRuns:    { method: 'get',  url: 'databricks-import-runs/runs' },
    getBatchErrors:  { method: 'get',  url: 'databricks-import-runs/errors' },
    // skipsCsv nao usa o wrapper vue-resource porque retorna blob — ver
    // ActionDownloadSkipsCsv em store/actions.js (fetch direto pra acessar
    // response.blob()). Mantido aqui so para documentar a rota existente.
    getSkipsCsv:     { method: 'get',  url: 'databricks-import-runs/skips-csv' },
    getSchedule:     { method: 'get',  url: 'databricks-import-runs/schedule' },
    saveSchedule:    { method: 'put',  url: 'databricks-import-runs/schedule' },
}
